import { ComponentType } from "react";

import FieldProLogger from "log/FieldProLogger";

import NewVersionAvailableScreen from "components/NewVersionAvailableScreen";
import isMissingChunkErrorMessage from "log/sentry/isMissingChunkErrorMessage";

const logger = FieldProLogger({});

export function lazyRetry<T extends ComponentType<any>>(
  componentImport: () => Promise<{ default: T }>,
  avoidCrash: boolean = process.env.NODE_ENV === "production",
): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    componentImport()
      .then((component) => {
        // in some cases webpack returns undefined : https://stackoverflow.com/questions/35240716/
        if (component === undefined) {
          resolve({
            default: NewVersionAvailableScreen as unknown as T,
          });
        }
        resolve(component);
      })
      .catch((error: Error) => {
        if (avoidCrash || isMissingChunkErrorMessage(error)) {
          resolve({
            default: NewVersionAvailableScreen as unknown as T,
          });
        } else {
          reject(error);
          logger.logError(error);
        }
      });
  });
}

